import { render, staticRenderFns } from "./NaverBlogIcon.vue?vue&type=template&id=22765cda&scoped=true&"
import script from "./NaverBlogIcon.vue?vue&type=script&lang=js&"
export * from "./NaverBlogIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22765cda",
  null
  
)

export default component.exports